var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1H5.5C3.01472 1 1 3.01472 1 5.5V14.5C1 16.9853 3.01472 19 5.5 19H14.5C16.9853 19 19 16.9853 19 14.5V5.5C19 3.01472 16.9853 1 14.5 1Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 9.43327C13.7111 10.1823 13.5832 10.9473 13.2344 11.6194C12.8857 12.2915 12.3339 12.8365 11.6575 13.177C10.9811 13.5174 10.2146 13.6359 9.46704 13.5156C8.71944 13.3953 8.02881 13.0423 7.49338 12.5069C6.95795 11.9715 6.60499 11.2809 6.48469 10.5333C6.36439 9.78567 6.48289 9.01918 6.82332 8.34281C7.16376 7.66644 7.7088 7.11464 8.38092 6.76589C9.05303 6.41714 9.81801 6.2892 10.567 6.40027C11.3311 6.51357 12.0384 6.86959 12.5846 7.41575C13.1307 7.96191 13.4867 8.66924 13.6 9.43327Z",
    stroke: "url(#paint1_linear)",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9502 5.0498H14.9592",
    stroke: "url(#paint2_linear)",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19,
    y1: 5,
    x2: 3.26051,
    y2: 23.9281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9025FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 13.639,
    y1: 7.96133,
    x2: 7.34317,
    y2: 15.5326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9025FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.9592,
    y1: 5.27203,
    x2: 14.9399,
    y2: 5.27224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9025FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7a5a0a20e8c99ee7bab0bed17ee64c8b.svg";
export { ForwardRef as ReactComponent };